import { render, staticRenderFns } from "./CardDeleteNegotiationAction.vue?vue&type=template&id=d1a23f22"
import script from "./CardDeleteNegotiationAction.vue?vue&type=script&lang=js"
export * from "./CardDeleteNegotiationAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports